import { render, staticRenderFns } from "./ChildSpecies.vue?vue&type=template&id=11af648b&"
import script from "./ChildSpecies.vue?vue&type=script&lang=js&"
export * from "./ChildSpecies.vue?vue&type=script&lang=js&"
import style0 from "./ChildSpecies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports